import { FormControlLabel, Switch } from "@mui/material";
import { Controller } from "react-hook-form";

import type { FieldComponent } from "../types";

const SwitchComponent: FieldComponent<never> = ({ field, methods }) => (
  <Controller
    name={field.name}
    control={methods.control}
    defaultValue={field.defaultValue || false}
    render={({ field: controllerField }) => (
      <FormControlLabel
        control={
          <Switch
            {...controllerField}
            checked={Boolean(controllerField.value)}
            disabled={field.disabled}
          />
        }
        label={field.label}
        className={field.className}
        style={field.style}
      />
    )}
  />
);

export default SwitchComponent;
